import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components';
import { Footer } from '../../containers';
import ContactForm from '../../components/contactform/ContactForm';
import Seo from '../../seo/Seo';
import { SITE, absoluteUrl } from '../../seo/site.mjs';
import { breadcrumbSchema, webPageSchema } from '../../seo/schemas';
import { PRODUCTS } from '../../data/products.mjs';
import { formatPrice } from '../../utils/currency.mjs';
import ProductCard from '../../components/products/ProductCard';
import '../services/services.css';

const PATH = '/productos';
const TITLE = 'Nuestros softwares: AgendaMax.do, ERP con FE, Internobis, ColegioMax y POS con FE';
const DESCRIPTION =
    'Software propio de Coralan Multiservice: AgendaMax.do (agenda y POS para salones y barberías), ERP con facturación electrónica e-CF, Internobis (CRM inmobiliario), ColegioMax con FE (gestión escolar) y POS con facturación electrónica para República Dominicana.';

/** Schema SoftwareApplication por producto; Offer sólo si el precio es público. */
export const productSchema = (p) => ({
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    '@id': `${absoluteUrl(PATH)}#${p.slug}`,
    name: p.name,
    description: p.tagline,
    applicationCategory: p.category || 'BusinessApplication',
    operatingSystem: 'Web',
    inLanguage: 'es',
    provider: { '@id': `${SITE.url}/#organization` },
    url: p.links?.site ? absoluteUrl(p.links.site) : absoluteUrl(PATH),
    ...(p.pricing?.public && p.pricing.from != null
        ? {
              offers: {
                  '@type': 'Offer',
                  price: String(p.pricing.from),
                  priceCurrency: p.currency,
                  availability: 'https://schema.org/InStock',
                  url: p.links?.site ? absoluteUrl(p.links.site) : absoluteUrl(PATH),
                  priceSpecification: {
                      '@type': 'UnitPriceSpecification',
                      price: String(p.pricing.from),
                      priceCurrency: p.currency,
                      unitText: p.pricing.period || 'mes',
                  },
              },
          }
        : {}),
});

const ProductsPage = () => {
    return (
        <div className="service-page">
            <Seo
                title={TITLE}
                description={DESCRIPTION}
                path={PATH}
                jsonLd={[
                    webPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION, type: 'CollectionPage' }),
                    ...PRODUCTS.map(productSchema),
                    breadcrumbSchema([
                        { name: 'Inicio', path: '/' },
                        { name: 'Productos', path: PATH },
                    ]),
                ]}
            />
            <Navbar />

            <section className="service-page__hero">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-9 service-page__hero-inner" data-reveal="up">
                            <nav className="service-page__breadcrumb" aria-label="Migas de pan">
                                <Link to="/">Inicio</Link>
                                <span className="service-page__breadcrumb-sep">/</span>
                                <span>Productos</span>
                            </nav>
                            <h1 className="service-page__title">Nuestros productos</h1>
                            <p className="service-page__subtitle">
                                Software como servicio desarrollado y mantenido por Coralan Multiservice. Los mismos productos
                                que usan nuestros clientes, listos para su empresa.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-page__body">
                <div className="container">
                    <div className="row">
                        {PRODUCTS.map((p) => (
                            <div className="col-12 col-md-6 mb-4" key={p.slug} data-reveal="up">
                                <ProductCard product={p} formatPrice={formatPrice} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <ContactForm />
            <Footer />
        </div>
    );
};

export default ProductsPage;
